const actions = {
    GET_COTIZACIONES_REQUEST: 'GET_COTIZACIONES_REQUEST',
    CREATE_COTIZACION_REQUEST: 'CREATE_COTIZACION_REQUEST',
    EDIT_COTIZACION_REQUEST: 'EDIT_COTIZACION_REQUEST',
    DELETE_COTIZACION_REQUEST: 'DELETE_COTIZACION_REQUEST',
    SEND_COTIZACION_BY_EMAIL: 'SEND_COTIZACION_BY_EMAIL',

    GET_COTIZACIONES_SUCCESS: 'GET_COTIZACIONES_SUCCESS',
    CREATE_COTIZACION_SUCCESS: 'CREATE_COTIZACION_SUCCESS',
    EDIT_COTIZACION_SUCCESS: 'EDIT_COTIZACION_SUCCESS',
    DELETE_COTIZACION_SUCCESS: 'DELETE_COTIZACION_SUCCESS',

    initDataCotizaciones: () => ({ type: actions.GET_COTIZACIONES_REQUEST }),
    createCotizacion: data => ({
        type: actions.CREATE_COTIZACION_REQUEST,
        payload: data
    }),
    editCotizacion: data => ({
        type: actions.EDIT_COTIZACION_REQUEST,
        payload: data
    }),
    deleteCotizacion: id => ({
        type: actions.DELETE_COTIZACION_REQUEST,
        payload: id
    }),
    sendCotizacionesByEmail: data => ({
        type: actions.SEND_COTIZACION_BY_EMAIL,
        payload: data
    }),

};
export default actions;